"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialChooseStep = void 0;
const react_1 = __importDefault(require("react"));
const SocialLogin_1 = require("./SocialLogin");
const css_manager_1 = require("@food/css-manager");
const SocialButtons_1 = require("./SocialButtons");
const Button_1 = require("@food/ui/build/dist/src/Button");
const auth_1 = require("../logic/auth");
const flexRow = (0, css_manager_1.registerClass)(() => `
	flex-direction: row;
`);
const flexCol = (0, css_manager_1.registerClass)(() => `
	flex-direction: column;
`);
const stepSection = (0, css_manager_1.registerClass)((theme, sc) => `
	padding: ${(theme.ratios.l / 4) * theme.font.baseSize}px ${theme.ratios.l *
    theme.font.baseSize}px;

	> div {
		display: flex;
		justify-content: space-between;

		> div {
			flex-grow: 1;
		}
	}
	
	.${sc('buttons')} {
		margin: ${theme.ratios.xl * theme.font.baseSize}px;
	}
	
	.${sc('renew-intro')} {
		margin: 1em;
		text-align: center;
	}
	
	.${sc('change-login-type')} {
		text-align: center;
	}
	
	.${sc('login-buttons')} {
		text-align: center;

		>button {
			margin: ${(theme.ratios.xl / 2) * theme.font.baseSize}px;
		}
	}
	
	&.${sc('layout', 'STANDARD')} > div > div {
		flex-basis: ${theme.font.baseSize}px;
	}
`);
const marginBottom = (0, css_manager_1.registerClass)((theme) => `margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;`);
const sc = (0, css_manager_1.currySC)(stepSection);
const SocialChooseStep = ({ t, logoElem, socialTypes, changePhase, orLogout, layout, performLogin, errors, isRenew, }) => {
    const socials = socialTypes.filter((social) => !isRenew || (0, auth_1.getLoginType)() === social);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, t(isRenew ? 'Renew your authentication' : 'Sign In / Register')),
        react_1.default.createElement("section", { className: (0, css_manager_1.classNames)(stepSection, sc('layout', layout)) },
            react_1.default.createElement("div", { className: layout === SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.STANDARD ? flexRow : flexCol },
                logoElem,
                react_1.default.createElement("div", { className: sc('buttons') },
                    react_1.default.createElement("div", { className: marginBottom },
                        react_1.default.createElement("div", { className: isRenew ? sc('renew-intro') : '' },
                            t(isRenew
                                ? 'Sign In again to renew your session'
                                : 'Sign In with your social accounts'),
                            ":")),
                    errors,
                    react_1.default.createElement(SocialButtons_1.SocialButtons, { socials: socials, onClick: performLogin, t: t }),
                    isRenew && (react_1.default.createElement("div", { className: sc('login-buttons') },
                        react_1.default.createElement(Button_1.Button, { onClick: orLogout, layout: Button_1.layouts.LINK, label: t `... or Logout` }))),
                    !isRenew && (react_1.default.createElement("div", { className: sc('change-login-type') },
                        react_1.default.createElement(Button_1.Button, { label: t `Sign In with username and password`, layout: Button_1.layouts.LINK, onClick: () => {
                                changePhase('TRADITIONAL_LOGIN');
                            } }))))))));
};
exports.SocialChooseStep = SocialChooseStep;
//# sourceMappingURL=SocialChooseStep.js.map